
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"900","height":"600","viewBox":"0 0 3 2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ED2939","d":"M2 0h1v2H2z"}}),_c('path',{attrs:{"fill":"#fff","d":"M1 0h1v2H1z"}}),_c('path',{attrs:{"fill":"#002395","d":"M0 0h1v2H0z"}})])
          )
        }
      }
    